import { getLogger } from "@expert/logging";
import type { ChallengeDetails } from "../api/getChallenge";

const logger = getLogger({
    module: "challenges",
    supportTeam: "sales",
});

export const findMyTeam = (teams: ChallengeDetails[], employeeId: string) => {
    const myTeam = teams.find((team) => team.empIds.includes(employeeId));
    if (!myTeam) {
        logger.error(teams, "challenge found for which current expert is not a participant");
        return teams[0];
    }
    return myTeam;
};

export const sortTeams = (teams: ChallengeDetails[], employeeId: string) => {
    teams.sort((a, _b) => (findMyTeam(teams, employeeId) === a ? -1 : 0));
};
